import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Icon, Table } from 'semantic-ui-react'
import { Link } from 'react-router'

import Permissions from 'Components/Permissions'
import TableHeader from 'Components/TableHeader'

import * as helpers from 'Global/Helpers/rugHelpers'
import * as styles from './styles'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

class TableLayout extends Component {
  static propTypes = {
    fromPage: PropTypes.string,
    handleSort: PropTypes.func.isRequired,
    rugs: PropTypes.array.isRequired,
    sortBy: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
    toggleSortOrder: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  static defaultProps = {
    fromPage: 'search',
  }

  render() {
    const { fromPage, handleSort, rugs, sortBy, sortOrder, user } = this.props

    const mappedTableRows = rugs.map(rug => (
      <Table.Row key={rug.id}>
        <Table.Cell>
          <Link to={{ pathname: `/rug/${rug.id}`, query: { fromPage } }} style={styles.link}>
            {rug.id}
          </Link>
        </Table.Cell>

        <Table.Cell>{rug.name}</Table.Cell>

        <Permissions
          permissions="rug.field.status"
          render={() => (
            <Table.Cell>
              <Icon name={helpers.getStatus(rug).icon} />
              {helpers.getStatus(rug).text}
            </Table.Cell>
          )}
        />

        <Permissions
          permissions="rug.field.size"
          render={() => <Table.Cell>{`${rug.sizeW}cm x ${rug.sizeH}cm (${rug.sizeQm}qm)`}</Table.Cell>}
        />

        <Permissions permissions="rug.field.quality" render={() => <Table.Cell>{rug.knotDescription}</Table.Cell>} />

        <Permissions
          permissions="rug.field.edges"
          render={() => <Table.Cell>{helpers.getDessinName(parseInt(rug.dessin, 10))}</Table.Cell>}
        />

        <Permissions permissions="rug.field.producerCode" render={() => <Table.Cell>{rug.producerCode}</Table.Cell>} />

        <Permissions permissions="rug.field.belCustomer" render={() => <Table.Cell>{rug.belCustomer}</Table.Cell>} />

        <Permissions
          permissions="rug.field.pictureSource"
          render={() => <Table.Cell>{helpers.getPictureSourceString(rug.pictureSource)}</Table.Cell>}
        />

        <Permissions permissions="rug.field.dateOrder" render={() => <Table.Cell>{getFormattedDateString(rug.dateOrder)}</Table.Cell>} />

        <Permissions
          permissions="rug.field.dateReceipt"
          render={() => <Table.Cell>{getFormattedDateString(rug.dateReceipt)}</Table.Cell>}
        />

        <Permissions
          permissions="rug.field.dateScanned"
          render={() => <Table.Cell>{getFormattedDateString(rug.dateScanned)}</Table.Cell>}
        />
      </Table.Row>
    ))

    return (
      <Table columns={11} size="small" fixed selectable sortable>
        <TableHeader handleSort={handleSort} sortBy={sortBy} sortOrder={sortOrder} user={user} />
        <Table.Body>{mappedTableRows}</Table.Body>
      </Table>
    )
  }
}

export default TableLayout
